import { cx } from '@/util/cx';
import { ReactNode, useRef } from 'react';
import { useBoolean, useOnClickOutside } from 'usehooks-ts';
import styles from './Dropdown.module.scss';

export function Dropdown({
  children,
  label,
  id,
}: {
  children: ReactNode;
  label: string;
  id?: string;
}) {
  const ref = useRef<HTMLDivElement>(null);
  const { setFalse, setTrue, value: open } = useBoolean(false);

  useOnClickOutside(ref, setFalse);

  return (
    <div className={styles.Dropdown} ref={ref}>
      <button
        type="button"
        className={styles.DropdownButton}
        aria-pressed={open ? 'true' : 'false'}
        onFocus={setTrue}
        onClick={setTrue}
        id={id}
      >
        <span>{label}</span>
      </button>
      <div className={cx(styles.DropdownPanel, open && styles.open)}>
        {children}
      </div>
    </div>
  );
}

export function RadioOption({
  children,
  onChange,
  checked,
  disabled,
  name,
  value,
}: { children: ReactNode } & React.InputHTMLAttributes<HTMLInputElement>) {
  return (
    <label className={styles.RadioOption}>
      <input
        type="radio"
        name={name}
        value={value}
        onChange={onChange}
        checked={checked}
        disabled={disabled}
      />
      {children}
    </label>
  );
}

export function CheckboxOption({
  onChange,
  checked,
  disabled,
  name,
  value,
  label,
  count,
}: {
  label: string;
  count: number;
} & React.InputHTMLAttributes<HTMLInputElement>) {
  return (
    <label className={styles.CheckboxOption}>
      <input
        type="checkbox"
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <span>{label}</span>

      {checked ? <strong>{count}</strong> : <b>{count}</b>}
    </label>
  );
}
